import { colors } from './colors.css';
import { nunito, nunitoSans, robotoMono } from './fonts.css';
const defaultTheme = {
    colors,
    fonts: {
        family: {
            nunito,
            nunitoSans,
            robotoMono,
            inherit: 'inherit'
        },
        size: {
            xs: '0.75rem',
            sm: '0.875rem',
            base: '1rem',
            md: '1.125rem',
            lg: '1.5rem',
            xl: '1.875rem',
            '2xl': '2.25rem',
            '3xl': '3rem',
            '4xl': '3.75rem',
            '5xl': '4.5rem',
            '6xl': '6rem',
            '7xl': '8rem',
            '8xl': '9rem',
            '9xl': '10rem'
        },
        weight: {
            light: '300',
            normal: '400',
            semibold: '600',
            bold: '700'
        },
        lineHeights: {
            xs: '1',
            sm: '1.25',
            base: '1.5',
            md: '1.5',
            lg: '1.75',
            xl: '1.75',
            '2xl': '2',
            '3xl': '2.25',
            '4xl': '2.5',
            '5xl': '2.75',
            '6xl': '3',
            '7xl': '3.5',
            '8xl': '3.75',
            '9xl': '4'
        },
        letterSpacings: {
            tighter: '-0.05em',
            tight: '-0.025em',
            normal: '0',
            wide: '0.025em',
            wider: '0.05em',
            widest: '0.1em'
        }
    },
    spaces: {
        xs: '0.5rem',
        sm: '0.75rem',
        md: '1rem',
        lg: '1.25rem',
        xl: '2.25rem',
        '2xl': '3rem',
        '3xl': '5rem',
        '4xl': '10rem',
        '5xl': '14rem',
        '6xl': '18rem',
        '7xl': '24rem',
        '8xl': '32rem',
        '9xl': '40rem',
        min: 'min-content',
        max: 'max-content',
        fit: 'fit-content',
        screen: '100vw',
        full: '100%',
        px: '1px',
        0: '0rem',
        1: '0.125rem',
        2: '0.25rem',
        3: '0.375rem',
        4: '0.5rem',
        5: '0.625rem',
        6: '0.75rem',
        7: '0.875rem',
        8: '1rem',
        9: '1.25rem',
        10: '1.5rem',
        11: '1.75rem',
        12: '2rem',
        13: '2.25rem',
        14: '2.5rem',
        15: '2.75rem',
        16: '3rem',
        17: '3.5rem',
        18: '4rem',
        20: '5rem',
        24: '6rem',
        28: '7rem',
        32: '8rem',
        36: '9rem',
        40: '10rem',
        44: '11rem',
        48: '12rem',
        52: '13rem',
        56: '14rem',
        60: '15rem',
        64: '16rem',
        72: '18rem',
        80: '20rem',
        96: '24rem'
    },
    radii: {
        xs: '0.125rem',
        sm: '0.25rem',
        base: '0.375rem',
        md: '0.5rem',
        lg: '0.75rem',
        xl: '1rem',
        '2xl': '1.5rem',
        '3xl': '2rem',
        full: '9999px',
        squared: '33%',
        rounded: '50%',
        pill: '9999px'
    },
    zIndices: {
        1: '100',
        2: '200',
        3: '300',
        4: '400',
        5: '500',
        6: '600',
        7: '700',
        8: '800',
        9: '900',
        10: '1000',
        max: '9999'
    },
    borders: {
        light: '1px',
        normal: '2px',
        bold: '3px',
        extrabold: '4px',
        black: '5px'
    },
    transitions: {
        fast: 'all 0.1s ease-in-out',
        normal: 'all 0.2s ease-in-out',
        slow: 'all 0.3s ease-in-out',
        colors: [
            'background-color 0.2s ease-in-out',
            'border-color 0.2s ease-in-out',
            'color 0.2s ease-in-out',
            'fill 0.2s ease-in-out',
            'stroke 0.2s ease-in-out',
            'opacity 0.2s ease-in-out',
            'box-shadow 0.2s ease-in-out'
        ].join(', ')
    },
    durations: {
        fast: '0.1s',
        normal: '0.2s',
        slow: '0.3s'
    }
};
export default defaultTheme;
//# sourceMappingURL=default-theme.js.map